export const EHRoutes = {
  admin: '/admin',
  operationalReview: '/businessreview',
  createReview: '/businessreview/reviews',
  reviewLanding: '/businessreview/reviews/:id',
};

export const getReviewLandingRoute = (reviewId: string): string =>
  EHRoutes.reviewLanding.replace(':id', reviewId);
